// src/components/ErrorBoundary.jsx
//
// Top-level render-error catch-all. Without this, any uncaught error anywhere in the
// component tree white-screens the entire app with no recovery path. Must be a class
// component — React has no hook equivalent for getDerivedStateFromError/componentDidCatch.
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught a render error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          padding: 40,
          textAlign: 'center',
          fontFamily: 'sans-serif',
        }}>
          <h2 style={{ margin: 0 }}>Something went wrong</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: 420 }}>
            CrewChain hit an unexpected error. Reloading the page usually fixes this — if it keeps happening, contact support.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: 'var(--branding-app-primary)',
              color: 'var(--branding-app-primary-fg)',
              border: 'none',
              borderRadius: 8,
              padding: '10px 24px',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
